import { CalendarDay } from 'further-ui/utils';
import { Vehicle } from 'further-types/lp/vehicle';

export const getLastFinancialYearStartDate = (
  vehicle: Vehicle | undefined,
  todayDate: Date,
): CalendarDay | undefined => {
  if (!vehicle) return undefined;
  const financialYearEndMonthIndex = vehicle.financialYearEndMonth - 1;
  const financialYearEndDay = vehicle.financialYearEndDay;
  const currentYear = todayDate.getFullYear();
  const thisYearsFinancialYearEnd = new Date(
    currentYear,
    financialYearEndMonthIndex,
    financialYearEndDay,
  );

  const hasCompletedThisFinancialYear =
    todayDate.getTime() >= thisYearsFinancialYearEnd.getTime();

  const lastCompletedFinancialYearEndYear = hasCompletedThisFinancialYear
    ? currentYear
    : currentYear - 1;

  const lastFinancialYearStart = new Date(
    lastCompletedFinancialYearEndYear,
    financialYearEndMonthIndex,
    financialYearEndDay + 1,
  );

  return new CalendarDay(lastFinancialYearStart);
};

export const buildDateRangeSubtitle = (
  vehicleName: string,
  startDate: CalendarDay | undefined,
  endDate: CalendarDay | undefined,
  lastFinancialYearStartDate: CalendarDay | undefined,
  today: CalendarDay,
): string => {
  const start = startDate?.toReadable();
  const end = endDate?.toReadable();
  const isFromLastFinancialYear =
    !!lastFinancialYearStartDate &&
    !!startDate?.isSameDay(lastFinancialYearStartDate);
  const isToToday = !!endDate?.isSameDay(today);

  if (start && end) {
    return `${vehicleName} as at ${
      isFromLastFinancialYear ? 'end of last financial year' : start
    } to ${isToToday ? 'today' : end}.`;
  }

  if (start) {
    return `${vehicleName} as at ${
      isFromLastFinancialYear ? 'end of last financial year' : start
    } to today.`;
  }

  if (end) {
    return `${vehicleName} as at ${isToToday ? 'today' : end}.`;
  }

  return `${vehicleName} as at end of last financial year to today.`;
};
